import React from "react";
import styled from "styled-components";

const PlayerYoutube = ({ linkPlay, linkDefault }) => {
    const idYtb = linkPlay.split("=")[1];

    return (
        <Container>
            <iframe
                width="100%"
                height="354"
                src={`https://www.youtube.com/embed/${idYtb}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
            ></iframe>
        </Container>
    );
};

const Container = styled.div`
    width: 630px;
    height: 354px;
    flex: none;

    @media only screen and (max-width: 767px) {
        width: 100%;
    }
`;

export default PlayerYoutube;
